import { render, staticRenderFns } from "./mediaEdit.vue?vue&type=template&id=22d3b9d0&scoped=true"
import script from "./mediaEdit.vue?vue&type=script&lang=js"
export * from "./mediaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d3b9d0",
  null
  
)

export default component.exports